import Vue from 'vue'
import View from './View'

Vue.component('EquipmentsView', View)
